import { useQuery } from "convex-helpers/react/cache/hooks";
import { api } from "@repo/convex/convex/_generated/api";

export const useMe = () => {
  return useQuery(api.me.get);
};
